<template>
    <EChart
        :options="chartOptions"
        card
        :header="$t('priceRangeAndDeviations')"
        :loading="loading"
        :tooltip="$t('chartHeaderTooltip')"
        class="shadow-none m-0"
    />
</template>



<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'PriceRangeAndDeviations',
        components: {
            EChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestReportSet: this.parentComponent.requestReportSet,
                requestReport: this.parentComponent.requestReport,
            };
        },
        computed: {
            loading() {
                return this.parentComponent.loading;
            },
            items() {
                return this.parentComponent.items || [];
            },
            chartOptions() {
                // 1) Filtr bezpieczeństwa – tylko rekordy z kompletnymi liczbami
                const safeRows = (this.items || []).filter(item => {
                    const values = [item.priceRangeMin, item.priceRangeMax, item.minPrice, item.maxPrice];
                    return values.every(v => v !== null && v !== undefined && Number.isFinite(Number(v)));
                });

                if (!safeRows.length) {
                    return { series: [] };
                }

                // 2) Oś X z nazw produktów (zachowujemy kolejność – zwykle main na górze)
                const xAxisData = safeRows.map(row => row.name);

                // 3) Dane świec: [open, close, lowest, highest]
                //    open  -> priceRangeMin   (po usunięciu skrajności)
                //    close -> priceRangeMax   (po usunięciu skrajności)
                //    lowest -> minPrice       (absolutne minimum)
                //    highest -> maxPrice      (absolutne maksimum)
                const seriesData = safeRows.map(row => [row.priceRangeMin, row.priceRangeMax, row.minPrice, row.maxPrice]);

                const fc = num => this.$format.currency(num);

                return {
                    legend: { show: false },
                    tooltip: {
                        trigger: 'item',
                        formatter: params => {
                            const idx = params?.dataIndex ?? -1;
                            const product = safeRows[idx];
                            if (!product) return '';
                            return `
                                <div style="display:flex;flex-direction:column;gap:3px;">
                                    <div><span style="font-weight:bold;">${product.name}</span></div>
                                    <div style="display:flex;gap:10px;">
                                        ${this.$t('priceRange')}:
                                        <span style="margin-left:auto; font-weight:bold;">
                                            ${fc(product.minPrice)} - ${fc(product.maxPrice)}
                                        </span>
                                    </div>
                                    <div style="display:flex;gap:10px;">
                                        ${this.$t('avgPrice')}:
                                        <span style="margin-left:auto; font-weight:bold;">${fc(product.avgPrice)}</span>
                                    </div>
                                    <div style="display:flex;gap:10px;">
                                        ${this.$t('minPrice')}:
                                        <span style="margin-left:auto; font-weight:bold;">${fc(product.minPrice)}</span>
                                    </div>
                                    <div style="display:flex;gap:10px;">
                                        ${this.$t('maxPrice')}:
                                        <span style="margin-left:auto; font-weight:bold;">${fc(product.maxPrice)}</span>
                                    </div>
                                </div>
                            `;
                        },
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                        axisLabel: { rotate: 10 },
                    },
                    yAxis: {
                        type: 'value',
                        name: this.$t('price'),
                    },
                    series: [
                        {
                            name: this.$t('priceRange'),
                            type: 'candlestick',
                            data: seriesData,
                            itemStyle: {
                                color: '#7e22ce',
                                color0: '#7e22ce',
                                borderColor: '#7e22ce',
                                borderColor0: '#7e22ce',
                            },
                        },
                    ],
                };
            },
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "chartHeaderTooltip": "Wykres prezentuje wartości dla ceny minimalnej i maksymalnej oraz odchylenia względem ceny średniej."
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "chartHeaderTooltip": "The chart shows values for the minimum and maximum price, as well as deviations from the average price."
}
</i18n>

